import axios, { CancelToken } from 'axios';
import { TimeZoneDto } from '@/features/devices/device.dto';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';

interface ITimezonesService {
	get(cancelToken?: CancelToken): Promise<ServiceResponse<TimeZoneDto[]>>;
}

class Service implements ITimezonesService {
	async get(cancelToken?: CancelToken): Promise<ServiceResponse<TimeZoneDto[]>> {
		const { data } = await axios.get<ServiceResponse<TimeZoneDto[]>>('/v2/time-zones', { cancelToken });
		return data;
	}
}

const TimezoneService: ITimezonesService = new Service();

export default TimezoneService;
